package de.xtl.retroguide.question

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.relocation.BringIntoViewRequester
import androidx.compose.foundation.relocation.bringIntoViewRequester
import androidx.compose.foundation.selection.toggleable
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Button
import androidx.compose.material3.Checkbox
import androidx.compose.material3.ElevatedCard
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.FilledTonalButton
import androidx.compose.material3.FilterChip
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.TopAppBar
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.Role
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import de.xtl.retroguide.AppTheme
import de.xtl.retroguide.InvitationShareButton
import de.xtl.retroguide.protocol.categories
import de.xtl.retroguide.protocol.maxAnswersPerParticipant
import de.xtl.retroguide.protocol.toCategorizedAnswer
import de.xtl.retroguide.protocol.toRadarAnswer
import de.xtl.retroguide.protocol.toRotiScore
import de.xtl.retroguide.join.JoinSessionAction
import de.xtl.retroguide.join.JoinSessionState
import de.xtl.retroguide.protocol.LobbyParticipant
import de.xtl.retroguide.protocol.BatteryLevel
import de.xtl.retroguide.protocol.ParticipantAnswerChoice
import de.xtl.retroguide.protocol.ParticipantRole
import de.xtl.retroguide.protocol.QuestionWidget
import de.xtl.retroguide.protocol.collectsTopics
import de.xtl.retroguide.protocol.AnswerCluster
import de.xtl.retroguide.protocol.toDotVote
import de.xtl.retroguide.protocol.toActionItem
import de.xtl.retroguide.protocol.VotingOption
import de.xtl.retroguide.protocol.DEFAULT_VOTES_PER_PARTICIPANT
import de.xtl.retroguide.protocol.RetroPhase
import de.xtl.retroguide.protocol.RetroQuestion
import de.xtl.retroguide.protocol.SessionAccess
import de.xtl.retroguide.protocol.SessionSnapshot
import de.xtl.retroguide.protocol.VisibleAnswer
import de.xtl.retroguide.protocol.WeatherMood
import de.xtl.retroguide.protocol.VisibleAnswerChoice
import org.jetbrains.compose.resources.stringResource
import retroguide.app.shared.generated.resources.Res
import retroguide.app.shared.generated.resources.answer_label
import retroguide.app.shared.generated.resources.answer_choice_title
import retroguide.app.shared.generated.resources.answer_edit_label
import retroguide.app.shared.generated.resources.answer_placeholder
import retroguide.app.shared.generated.resources.battery_answer_prompt
import retroguide.app.shared.generated.resources.battery_percent
import retroguide.app.shared.generated.resources.cancel_action
import retroguide.app.shared.generated.resources.delete_answer_action
import retroguide.app.shared.generated.resources.edit_answer_action
import retroguide.app.shared.generated.resources.leave_action
import retroguide.app.shared.generated.resources.next_question_action
import retroguide.app.shared.generated.resources.no_answer_action
import retroguide.app.shared.generated.resources.no_answer_status
import retroguide.app.shared.generated.resources.open_status
import retroguide.app.shared.generated.resources.own_answers_title
import retroguide.app.shared.generated.resources.participant_answer_count
import retroguide.app.shared.generated.resources.question_progress
import retroguide.app.shared.generated.resources.current_timer_label
import retroguide.app.shared.generated.resources.current_timer_supporting_text
import retroguide.app.shared.generated.resources.start_current_timer_action
import retroguide.app.shared.generated.resources.retro_finished
import retroguide.app.shared.generated.resources.finish_retro_action
import retroguide.app.shared.generated.resources.reveal_answers_action
import retroguide.app.shared.generated.resources.no_more_answers_action
import retroguide.app.shared.generated.resources.no_more_answers_status
import retroguide.app.shared.generated.resources.revealed_answers_title
import retroguide.app.shared.generated.resources.submit_answer_action
import retroguide.app.shared.generated.resources.update_answer_action
import retroguide.app.shared.generated.resources.weather_answer_prompt
import retroguide.app.shared.generated.resources.weather_cloudy
import retroguide.app.shared.generated.resources.weather_partly_cloudy
import retroguide.app.shared.generated.resources.weather_rainy
import retroguide.app.shared.generated.resources.weather_stormy
import retroguide.app.shared.generated.resources.weather_sunny
import retroguide.app.shared.generated.resources.question_answer_visibility_label
import retroguide.app.shared.generated.resources.cluster_mode_start
import retroguide.app.shared.generated.resources.cluster_mode_done

@Composable
fun ModeratorQuestionScreen(
    state: JoinSessionState,
    onAction: (JoinSessionAction) -> Unit,
) {
    val session = state.session ?: return
    val participants = session.participants.filter { it.role == ParticipantRole.PARTICIPANT }
    Scaffold(
        topBar = { SessionTopAppBar(state) },
    ) { contentPadding ->
        Box(
            modifier = Modifier.fillMaxSize().padding(contentPadding).verticalScroll(rememberScrollState()),
            contentAlignment = Alignment.TopCenter,
        ) {
            Column(
                modifier = Modifier
                    .widthIn(max = 412.dp)
                    .fillMaxWidth()
                    .padding(horizontal = 24.dp, vertical = 24.dp),
                verticalArrangement = Arrangement.spacedBy(16.dp),
            ) {
                ElevatedCard(modifier = Modifier.fillMaxWidth()) {
                    Text(
                        session.currentQuestion?.text.orEmpty(),
                        modifier = Modifier.padding(20.dp),
                        style = MaterialTheme.typography.headlineSmall,
                    )
                }
                if (session.phase == RetroPhase.QUESTION_ACTIVE && session.currentQuestion?.durationSeconds == null) {
                    OutlinedTextField(
                        value = state.currentTimerDraft,
                        onValueChange = { onAction(JoinSessionAction.OnCurrentTimerChange(it)) },
                        label = { Text(stringResource(Res.string.current_timer_label)) },
                        supportingText = { Text(stringResource(Res.string.current_timer_supporting_text)) },
                        singleLine = true,
                        enabled = !state.isLoading,
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                        modifier = Modifier.fillMaxWidth(),
                    )
                    Button(
                        onClick = { onAction(JoinSessionAction.OnStartCurrentQuestionTimerClick) },
                        enabled = state.canStartCurrentQuestionTimer,
                        modifier = Modifier.fillMaxWidth(),
                    ) {
                        Text(stringResource(Res.string.start_current_timer_action))
                    }
                }
                if (session.phase == RetroPhase.QUESTION_ACTIVE) {
                    val visibilityLabel = stringResource(Res.string.question_answer_visibility_label)
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween,
                    ) {
                        Text(visibilityLabel, style = MaterialTheme.typography.bodyLarge)
                        androidx.compose.material3.Switch(
                            checked = session.currentQuestion?.showAllParticipantAnswers == true,
                            onCheckedChange = {
                                onAction(JoinSessionAction.OnCurrentQuestionAnswerVisibilityChange(it))
                            },
                            enabled = !state.isLoading,
                            modifier = Modifier.semantics { contentDescription = visibilityLabel },
                        )
                    }
                    participants.forEach { participant ->
                        val count = session.answerCountsByParticipantId[participant.id] ?: 0
                        val answerChoice = session.answerChoicesByParticipantId[participant.id]
                        ElevatedCard(modifier = Modifier.fillMaxWidth()) {
                            Row(
                                modifier = Modifier.fillMaxWidth().padding(16.dp),
                                horizontalArrangement = Arrangement.spacedBy(16.dp),
                            ) {
                                Text(
                                    participant.displayName,
                                    modifier = Modifier.weight(1f),
                                    style = MaterialTheme.typography.titleMedium,
                                )
                                Text(
                                    if (count > 0) {
                                        stringResource(Res.string.participant_answer_count, count)
                                    } else if (answerChoice != null) {
                                        answerChoice.label()
                                    } else {
                                        stringResource(Res.string.open_status)
                                    },
                                    color = if (count > 0 || answerChoice != null) {
                                        MaterialTheme.colorScheme.primary
                                    } else {
                                        MaterialTheme.colorScheme.onSurfaceVariant
                                    },
                                    style = MaterialTheme.typography.titleMedium,
                                )
                            }
                        }
                    }
                }
                when (session.phase) {
                    RetroPhase.QUESTION_ACTIVE -> Button(
                        onClick = { onAction(JoinSessionAction.OnRevealAnswersClick) },
                        enabled = session.submittedParticipantIds.isNotEmpty() && !state.isLoading,
                        modifier = Modifier.fillMaxWidth(),
                    ) {
                        Text(stringResource(Res.string.reveal_answers_action))
                    }

                    RetroPhase.ANSWERS_REVEALED -> {
                        ModeratorRevealedAnswers(state, onAction)
                        RevealedAnswerChoices(session.visibleAnswerChoices)
                        val hasNextQuestion = (session.questionIndex ?: 0) + 1 < session.questionCount
                        Button(
                            onClick = { onAction(JoinSessionAction.OnNextQuestionClick) },
                            enabled = !state.isLoading,
                            modifier = Modifier.fillMaxWidth(),
                        ) {
                            Text(
                                stringResource(
                                    if (hasNextQuestion) Res.string.next_question_action else Res.string.finish_retro_action,
                                ),
                            )
                        }
                    }

                    RetroPhase.FINISHED -> Unit
                    RetroPhase.LOBBY -> Unit
                }
                TextButton(
                    onClick = { onAction(JoinSessionAction.OnLeaveLobbyClick) },
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                ) {
                    Text(stringResource(Res.string.leave_action))
                }
            }
        }
    }
}

@Composable
fun ParticipantQuestionScreen(
    state: JoinSessionState,
    onAction: (JoinSessionAction) -> Unit,
) {
    val session = state.session ?: return
    val widget = session.currentQuestion?.widget ?: QuestionWidget.TEXT
    val submitAnswerRequester = remember { BringIntoViewRequester() }
    Scaffold(
        topBar = { SessionTopAppBar(state) },
    ) { contentPadding ->
        Box(
            modifier = Modifier.fillMaxSize().padding(contentPadding).verticalScroll(rememberScrollState()),
            contentAlignment = Alignment.TopCenter,
        ) {
            Column(
                modifier = Modifier
                    .widthIn(max = 412.dp)
                    .fillMaxWidth()
                    .imePadding()
                    .padding(horizontal = 24.dp, vertical = 24.dp),
                verticalArrangement = Arrangement.spacedBy(16.dp),
            ) {
                Text(session.currentQuestion?.text.orEmpty(), style = MaterialTheme.typography.headlineSmall)
                if (session.phase == RetroPhase.QUESTION_ACTIVE) {
                    LaunchedEffect(state.answerDraft) {
                        val hasTextInput = widget == QuestionWidget.TEXT || widget == QuestionWidget.ACTION_ITEMS ||
                            widget.categories.isNotEmpty()
                        if (hasTextInput && state.answerDraft.isNotEmpty()) submitAnswerRequester.bringIntoView()
                    }
                    if (session.ownAnswers.isNotEmpty()) {
                        Text(stringResource(Res.string.own_answers_title), style = MaterialTheme.typography.titleMedium)
                        session.ownAnswers.forEach { answer ->
                            OwnAnswer(
                                answer = answer,
                                widget = widget,
                                enabled = state.canModifyOwnAnswers,
                                onEdit = { onAction(JoinSessionAction.OnEditAnswerClick(answer.id)) },
                                onDelete = { onAction(JoinSessionAction.OnDeleteAnswerClick(answer.id)) },
                                votingOptions = session.votingOptions,
                            )
                        }
                    }
                    val inputEnabled = if (state.editingAnswerId == null) {
                        state.isAnsweringAllowed
                    } else {
                        state.canModifyOwnAnswers
                    }
                    val canAddOrEdit = state.editingAnswerId != null ||
                        session.ownAnswers.size < widget.maxAnswersPerParticipant
                    if (canAddOrEdit) {
                        when (widget) {
                            QuestionWidget.TEXT -> OutlinedTextField(
                                value = state.answerDraft,
                                onValueChange = { onAction(JoinSessionAction.OnAnswerChange(it)) },
                                label = {
                                    Text(
                                        stringResource(
                                            if (state.editingAnswerId == null) {
                                                Res.string.answer_label
                                            } else {
                                                Res.string.answer_edit_label
                                            },
                                        ),
                                    )
                                },
                                placeholder = { Text(stringResource(Res.string.answer_placeholder)) },
                                enabled = inputEnabled,
                                minLines = 5,
                                modifier = Modifier.fillMaxWidth(),
                            )

                            QuestionWidget.BATTERY -> BatteryAnswerPicker(
                                value = state.answerDraft,
                                enabled = inputEnabled,
                                onValueChange = { onAction(JoinSessionAction.OnAnswerChange(it)) },
                            )

                            QuestionWidget.WEATHER -> WeatherAnswerPicker(
                                value = state.answerDraft,
                                enabled = inputEnabled,
                                onValueChange = { onAction(JoinSessionAction.OnAnswerChange(it)) },
                            )

                            QuestionWidget.SAILBOAT, QuestionWidget.MAD_SAD_GLAD, QuestionWidget.STARFISH,
                            QuestionWidget.FOUR_L, QuestionWidget.HOT_AIR_BALLOON, QuestionWidget.SPEEDCAR,
                            QuestionWidget.KALM, QuestionWidget.DAKI -> CategoryAnswerPicker(
                                categories = widget.categories,
                                selected = state.answerCategoryDraft,
                                text = state.answerDraft,
                                editing = state.editingAnswerId != null,
                                enabled = inputEnabled,
                                onCategoryChange = { onAction(JoinSessionAction.OnAnswerCategoryChange(it)) },
                                onTextChange = { onAction(JoinSessionAction.OnAnswerChange(it)) },
                            )

                            QuestionWidget.ROTI -> RotiAnswerPicker(
                                value = state.answerDraft,
                                enabled = inputEnabled,
                                onValueChange = { onAction(JoinSessionAction.OnAnswerChange(it)) },
                            )

                            QuestionWidget.DOT_VOTING -> DotVotePicker(
                                options = session.votingOptions,
                                budget = session.currentQuestion?.votesPerParticipant ?: DEFAULT_VOTES_PER_PARTICIPANT,
                                value = state.answerDraft,
                                enabled = inputEnabled,
                                onValueChange = { onAction(JoinSessionAction.OnAnswerChange(it)) },
                            )

                            QuestionWidget.ACTION_ITEMS -> ActionItemInput(
                                value = state.answerDraft,
                                enabled = inputEnabled,
                                onValueChange = { onAction(JoinSessionAction.OnAnswerChange(it)) },
                            )

                            QuestionWidget.TEAM_RADAR -> RadarAnswerPicker(
                                value = state.answerDraft,
                                enabled = inputEnabled,
                                onValueChange = { onAction(JoinSessionAction.OnAnswerChange(it)) },
                            )
                        }
                        Button(
                            onClick = { onAction(JoinSessionAction.OnSubmitAnswerClick) },
                            enabled = state.canSubmitAnswer,
                            modifier = Modifier.fillMaxWidth().bringIntoViewRequester(submitAnswerRequester),
                        ) {
                            Text(
                                stringResource(
                                    if (state.editingAnswerId == null) {
                                        Res.string.submit_answer_action
                                    } else {
                                        Res.string.update_answer_action
                                    },
                                ),
                            )
                        }
                    }
                    Text(stringResource(Res.string.answer_choice_title), style = MaterialTheme.typography.titleMedium)
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(8.dp),
                    ) {
                        ParticipantAnswerChoice.entries.forEach { choice ->
                            val selected = session.ownAnswerChoice == choice
                            FilterChip(
                                selected = selected,
                                onClick = {
                                    onAction(JoinSessionAction.OnAnswerChoiceChange(choice.takeUnless { selected }))
                                },
                                label = { Text(choice.actionLabel()) },
                                enabled = state.canSetAnswerChoice &&
                                    (choice != ParticipantAnswerChoice.NO_ANSWER || session.ownAnswers.isEmpty()),
                                modifier = Modifier.weight(1f),
                            )
                        }
                    }
                    if (state.editingAnswerId != null) {
                        TextButton(
                            onClick = { onAction(JoinSessionAction.OnCancelAnswerEditClick) },
                            enabled = !state.isLoading,
                            modifier = Modifier.align(Alignment.CenterHorizontally),
                        ) {
                            Text(stringResource(Res.string.cancel_action))
                        }
                    }
                    if (session.currentQuestion?.showAllParticipantAnswers == true) {
                        RevealedAnswers(
                            session.visibleAnswers.filterNot { visible ->
                                session.ownAnswers.any { it.id == visible.id }
                            },
                            session.visibleAnswerChoices,
                            widget,
                            session.clusters,
                            session.votingOptions,
                        )
                    }
                } else {
                    RevealedAnswers(
                        session.visibleAnswers,
                        session.visibleAnswerChoices,
                        widget,
                        session.clusters,
                        session.votingOptions,
                    )
                    if (session.phase == RetroPhase.FINISHED) {
                        Text(stringResource(Res.string.retro_finished), style = MaterialTheme.typography.titleMedium)
                    }
                }
                TextButton(
                    onClick = { onAction(JoinSessionAction.OnLeaveLobbyClick) },
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                ) {
                    Text(stringResource(Res.string.leave_action))
                }
            }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
private fun SessionTopAppBar(
    state: JoinSessionState,
) {
    TopAppBar(
        title = {
            state.session?.let { session ->
                Text(
                    stringResource(
                        Res.string.question_progress,
                        session.questionIndex?.plus(1) ?: 0,
                        session.questionCount,
                    ),
                    style = MaterialTheme.typography.titleLarge,
                )
            }
        },
        actions = {
            state.questionRemainingSeconds?.let {
                Text(
                    it.asTimerText(),
                    style = MaterialTheme.typography.titleMedium,
                    modifier = Modifier.padding(end = 16.dp),
                )
            }
            InvitationShareButton(state, iconOnly = true)
        },
    )
}

private fun Int.asTimerText() = "${this / 60}:${(this % 60).toString().padStart(2, '0')}"

@Composable
private fun RevealedAnswers(
    answers: List<VisibleAnswer>,
    answerChoices: List<VisibleAnswerChoice>,
    widget: QuestionWidget,
    clusters: List<AnswerCluster> = emptyList(),
    votingOptions: List<VotingOption> = emptyList(),
) {
    Text(stringResource(Res.string.revealed_answers_title), style = MaterialTheme.typography.titleMedium)
    AnswerBoard(answers, widget, clusters, votingOptions) { answer -> ParticipantAnswer(answer, widget) }
    RevealedAnswerChoices(answerChoices)
}

@Composable
private fun RevealedAnswerChoices(answerChoices: List<VisibleAnswerChoice>) {
    answerChoices.forEach { ParticipantAnswerChoiceCard(it) }
}

@Composable
internal fun ParticipantAnswerChoiceCard(answerChoice: VisibleAnswerChoice) {
    ElevatedCard(modifier = Modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier.padding(16.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            Text(
                answerChoice.participantName,
                color = MaterialTheme.colorScheme.primary,
                style = MaterialTheme.typography.titleMedium,
            )
            Text(answerChoice.choice.label(), style = MaterialTheme.typography.titleLarge)
        }
    }
}

@Composable
private fun ParticipantAnswerChoice.actionLabel() = stringResource(
    when (this) {
        ParticipantAnswerChoice.NO_ANSWER -> Res.string.no_answer_action
        ParticipantAnswerChoice.NO_MORE_ANSWERS -> Res.string.no_more_answers_action
    },
)

@Composable
internal fun ParticipantAnswerChoice.label() = stringResource(
    when (this) {
        ParticipantAnswerChoice.NO_ANSWER -> Res.string.no_answer_status
        ParticipantAnswerChoice.NO_MORE_ANSWERS -> Res.string.no_more_answers_status
    },
)

@Composable
private fun ModeratorRevealedAnswers(
    state: JoinSessionState,
    onAction: (JoinSessionAction) -> Unit,
) {
    val session = state.session ?: return
    val answers = session.visibleAnswers
    val widget = session.currentQuestion?.widget ?: QuestionWidget.TEXT
    val canCluster = widget.collectsTopics && answers.isNotEmpty()
    Row(verticalAlignment = Alignment.CenterVertically) {
        Text(
            stringResource(Res.string.revealed_answers_title),
            modifier = Modifier.weight(1f),
            style = MaterialTheme.typography.titleMedium,
        )
        if (canCluster) {
            FilledTonalButton(
                onClick = { onAction(JoinSessionAction.OnClusterModeChange(!state.isClustering)) },
                enabled = !state.isLoading,
            ) {
                Text(stringResource(if (state.isClustering) Res.string.cluster_mode_done else Res.string.cluster_mode_start))
            }
        }
    }
    if (canCluster && state.isClustering) {
        ClusterComposer(
            selectionCount = state.clusterSelection.size,
            name = state.clusterNameDraft,
            enabled = !state.isLoading,
            onNameChange = { onAction(JoinSessionAction.OnClusterNameChange(it)) },
            onCreate = { onAction(JoinSessionAction.OnCreateClusterClick) },
        )
    }
    AnswerBoard(
        answers = answers,
        widget = widget,
        clusters = session.clusters,
        votingOptions = session.votingOptions,
        onDeleteCluster = if (canCluster) {
            { clusterId: String -> onAction(JoinSessionAction.OnDeleteClusterClick(clusterId)) }
        } else {
            null
        },
    ) { answer ->
        val selecting = canCluster && state.isClustering
        val checked = if (selecting) answer.id in state.clusterSelection else answer.id in state.processedAnswerIds
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(vertical = 8.dp)
                .toggleable(
                    value = checked,
                    role = Role.Checkbox,
                    onValueChange = {
                        onAction(
                            if (selecting) {
                                JoinSessionAction.OnClusterAnswerToggle(answer.id)
                            } else {
                                JoinSessionAction.OnAnswerProcessedChange(answer.id, it)
                            },
                        )
                    },
                ),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Checkbox(checked = checked, onCheckedChange = null)
            ParticipantAnswer(
                answer,
                widget,
                Modifier.weight(1f).then(
                    if (selecting && checked) {
                        Modifier.border(2.dp, MaterialTheme.colorScheme.primary, RoundedCornerShape(12.dp))
                    } else {
                        Modifier
                    },
                ),
            )
        }
    }
}

@Composable
internal fun ParticipantAnswer(
    answer: VisibleAnswer,
    widget: QuestionWidget = QuestionWidget.TEXT,
    modifier: Modifier = Modifier,
    votingOptions: List<VotingOption> = emptyList(),
) {
    ElevatedCard(modifier = modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier.padding(16.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            Text(
                answer.participantName,
                color = MaterialTheme.colorScheme.primary,
                style = MaterialTheme.typography.titleMedium,
            )
            AnswerContent(answer.content, widget, votingOptions)
        }
    }
}

@Composable
private fun OwnAnswer(
    answer: VisibleAnswer,
    widget: QuestionWidget,
    enabled: Boolean,
    onEdit: () -> Unit,
    onDelete: () -> Unit,
    votingOptions: List<VotingOption> = emptyList(),
) {
    Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
        ParticipantAnswer(answer, widget, votingOptions = votingOptions)
        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
            TextButton(onClick = onEdit, enabled = enabled) {
                Text(stringResource(Res.string.edit_answer_action))
            }
            TextButton(onClick = onDelete, enabled = enabled) {
                Text(stringResource(Res.string.delete_answer_action))
            }
        }
    }
}

@Composable
private fun BatteryAnswerPicker(
    value: String,
    enabled: Boolean,
    onValueChange: (String) -> Unit,
) {
    Text(stringResource(Res.string.battery_answer_prompt), style = MaterialTheme.typography.titleMedium)
    FlowRow(
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalArrangement = Arrangement.spacedBy(8.dp),
    ) {
        BatteryLevel.entries.forEach { level ->
            FilterChip(
                selected = value == level.name,
                onClick = { onValueChange(level.name) },
                enabled = enabled,
                label = {
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(8.dp),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        BatteryIndicator(level)
                        Text(stringResource(Res.string.battery_percent, level.percent))
                    }
                },
            )
        }
    }
}

@Composable
private fun WeatherAnswerPicker(
    value: String,
    enabled: Boolean,
    onValueChange: (String) -> Unit,
) {
    Text(stringResource(Res.string.weather_answer_prompt), style = MaterialTheme.typography.titleMedium)
    FlowRow(
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalArrangement = Arrangement.spacedBy(8.dp),
    ) {
        WeatherMood.entries.forEach { mood ->
            FilterChip(
                selected = value == mood.name,
                onClick = { onValueChange(mood.name) },
                enabled = enabled,
                label = { Text("${mood.emoji} ${mood.label()}") },
            )
        }
    }
}

@Composable
private fun AnswerContent(content: String, widget: QuestionWidget, votingOptions: List<VotingOption> = emptyList()) {
    when (widget) {
        QuestionWidget.TEXT -> Text(
            content,
            style = MaterialTheme.typography.titleLarge,
        )
        QuestionWidget.BATTERY -> BatteryLevel.entries.firstOrNull { it.name == content }?.let { level ->
            Row(
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                BatteryIndicator(level)
                Text(stringResource(Res.string.battery_percent, level.percent), style = MaterialTheme.typography.titleLarge)
            }
        } ?: Text(content, style = MaterialTheme.typography.titleLarge)

        QuestionWidget.WEATHER -> WeatherMood.entries.firstOrNull { it.name == content }?.let { mood ->
            Text("${mood.emoji} ${mood.label()}", style = MaterialTheme.typography.titleLarge)
        } ?: Text(content, style = MaterialTheme.typography.titleLarge)

        QuestionWidget.SAILBOAT, QuestionWidget.MAD_SAD_GLAD, QuestionWidget.STARFISH, QuestionWidget.FOUR_L,
        QuestionWidget.HOT_AIR_BALLOON, QuestionWidget.SPEEDCAR, QuestionWidget.KALM, QuestionWidget.DAKI ->
            content.toCategorizedAnswer()?.let { answer ->
                Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                    CategoryBadge(answer.category)
                    Text(answer.text, style = MaterialTheme.typography.titleLarge)
                }
            } ?: Text(content, style = MaterialTheme.typography.titleLarge)

        QuestionWidget.ROTI -> content.toRotiScore()?.let { RotiAnswerContent(it) }
            ?: Text(content, style = MaterialTheme.typography.titleLarge)

        QuestionWidget.DOT_VOTING -> content.toDotVote()?.let { DotVoteContent(it, votingOptions) }
            ?: Text(content, style = MaterialTheme.typography.titleLarge)

        QuestionWidget.ACTION_ITEMS -> content.toActionItem()?.let { ActionItemContent(it) }
            ?: Text(content, style = MaterialTheme.typography.titleLarge)

        QuestionWidget.TEAM_RADAR -> content.toRadarAnswer()?.let { RadarAnswerContent(it) }
            ?: Text(content, style = MaterialTheme.typography.titleLarge)
    }
}

@Composable
private fun BatteryIndicator(level: BatteryLevel) {
    val color = when (level) {
        BatteryLevel.LOW -> Color(0xFFD32F2F)
        BatteryLevel.MEDIUM -> Color(0xFFF9A825)
        BatteryLevel.HIGH -> Color(0xFF2E7D32)
    }
    Row(verticalAlignment = Alignment.CenterVertically) {
        Box(
            Modifier
                .width(38.dp)
                .height(20.dp)
                .border(2.dp, color, RoundedCornerShape(4.dp))
                .padding(2.dp),
        ) {
            Box(
                Modifier
                    .fillMaxHeight()
                    .fillMaxWidth(level.percent / 100f)
                    .background(color, RoundedCornerShape(1.dp)),
            )
        }
        Box(Modifier.width(4.dp).height(10.dp).background(color, RoundedCornerShape(1.dp)))
    }
}

private val WeatherMood.emoji
    get() = when (this) {
        WeatherMood.SUNNY -> "☀️"
        WeatherMood.PARTLY_CLOUDY -> "🌤️"
        WeatherMood.CLOUDY -> "☁️"
        WeatherMood.RAINY -> "🌧️"
        WeatherMood.STORMY -> "⛈️"
    }

@Composable
private fun WeatherMood.label() = stringResource(
    when (this) {
        WeatherMood.SUNNY -> Res.string.weather_sunny
        WeatherMood.PARTLY_CLOUDY -> Res.string.weather_partly_cloudy
        WeatherMood.CLOUDY -> Res.string.weather_cloudy
        WeatherMood.RAINY -> Res.string.weather_rainy
        WeatherMood.STORMY -> Res.string.weather_stormy
    },
)

private val previewParticipants = listOf(
    LobbyParticipant("1", "Mara", ParticipantRole.MODERATOR),
    LobbyParticipant("2", "Alex", ParticipantRole.PARTICIPANT),
    LobbyParticipant("3", "Sam", ParticipantRole.PARTICIPANT),
)

private fun previewState(
    role: ParticipantRole,
    phase: RetroPhase = RetroPhase.QUESTION_ACTIVE,
) = JoinSessionState(
    sessionCode = "7KD4MQ",
    questionRemainingSeconds = 180,
    access = SessionAccess(
        sessionCode = "7KD4MQ",
        participantId = if (role == ParticipantRole.MODERATOR) "1" else "2",
        accessToken = "preview-token",
        role = role,
        title = "Team-Retro",
    ),
    session = SessionSnapshot(
        sessionCode = "7KD4MQ",
        title = "Team-Retro",
        participants = previewParticipants,
        phase = phase,
        currentQuestion = RetroQuestion("question-1", "Was lief in diesem Sprint gut?", 300),
        questionIndex = 0,
        questionCount = 3,
        answerCount = 2,
        submittedParticipantIds = listOf("2"),
        answerCountsByParticipantId = mapOf("2" to 2),
        questionRemainingSeconds = 180,
        isAnsweringAllowed = true,
        ownAnswers = if (role == ParticipantRole.PARTICIPANT) {
            listOf(
                VisibleAnswer("answer-1", "Alex", "Die Zusammenarbeit im Pairing."),
                VisibleAnswer("answer-2", "Alex", "Die kurzen Abstimmungswege."),
            )
        } else {
            emptyList()
        },
        visibleAnswers = if (phase == RetroPhase.ANSWERS_REVEALED) {
            listOf(
                VisibleAnswer("answer-1", "Alex", "Die Zusammenarbeit im Pairing."),
                VisibleAnswer("answer-2", "Sam", "Die kurzen Abstimmungswege."),
            )
        } else {
            emptyList()
        },
    ),
)

@Preview
@Composable
private fun ModeratorQuestionScreenPreview() {
    AppTheme {
        ModeratorQuestionScreen(
            previewState(ParticipantRole.MODERATOR, RetroPhase.ANSWERS_REVEALED),
            onAction = {},
        )
    }
}

@Preview
@Composable
private fun ParticipantQuestionScreenPreview() {
    AppTheme { ParticipantQuestionScreen(previewState(ParticipantRole.PARTICIPANT), onAction = {}) }
}
